import { IParcelStates, IParcelStatesPersistence } from '../interfaces';

export class ParcelStatesMapper {
  public static toDomain(item: IParcelStatesPersistence): IParcelStates {
    return {
      _id: item._id,
      stateId: item.state_id,
      state: item.state,
      comment: item.comment,
      author: item.author,
      createdAt: item.createdAt ?? null,
      updatedAt: item.updatedAt ?? null,
    };
  }
}
